import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ComptageRule } from '../models/models';

@Injectable({
    providedIn: 'root'
})
export class ComptageRuleService {
    private readonly apiUrl = `${environment.apiUrl}/comptage-rules`;

    constructor(private http: HttpClient) { }

    getAllRules(showArchived: boolean = false): Observable<ComptageRule[]> {
        return this.http.get<ComptageRule[]>(this.apiUrl, {
            params: { showArchived }
        });
    }

    getActiveRule(): Observable<ComptageRule> {
        return this.http.get<ComptageRule>(`${this.apiUrl}/active`);
    }

    createRule(rule: ComptageRule): Observable<ComptageRule> {
        return this.http.post<ComptageRule>(this.apiUrl, rule);
    }

    updateRule(id: number, rule: ComptageRule): Observable<ComptageRule> {
        return this.http.put<ComptageRule>(`${this.apiUrl}/${id}`, rule);
    }

    activateRule(id: number): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${id}/activate`, {});
    }

    deleteRule(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    canDeleteRule(id: number): Observable<boolean> {
        return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
    }
}
